import React, { useEffect } from 'react';
import learn from '../../assets/pngs/learn.png';
import { Form, Button, Checkbox, Spin } from 'antd';
import { useNavigate } from 'react-router';
import FormInput from '../../components/Form/FormInput';
import Logo from '../../components/Logo/Logo';
import userStore from '../../zustand/store/userStore';
import Google from '../../components/Google/Google';
import { useLocation } from 'react-router-dom';

const Login = () => {
	const { authToken, data, user, userLogin, loading, resetState } = userStore();

	const Navigate = useNavigate();
	const location = useLocation(); 
	const queryParams = new URLSearchParams(location.search);
	const roleFromURL = queryParams.get('role');
	const onFinish = async (values) => {
		await userLogin(values);
	};

	useEffect(() => {
		if (authToken) {
			if (user?.role == 'student') Navigate("/student-dashboard");
			if (user?.role == 'teacher') Navigate("/teacher-dashboard");
			if (user?.role == 'admin') Navigate("/admin-dashboard");
			if (user?.role == 'parent') Navigate("/parent-dashboard");
		}
		if (data?.otpSend) {
			Navigate("/otp-verify");
			resetState();
		}
	}, [authToken, data, Navigate]);

	return (
		<div className="w-screen h-screen flex items-center justify-center bg-[#F6F6F6] ">
			<div className="w-full h-full flex flex-col md:flex-row shadow-lg overflow-hidden">
				<div className="w-full md:w-1/2 p-8 flex flex-col justify-center bg-[#F6F6F6] items-center">
					<div className="flex justify-center mb-6">
						<div className="w-10 h-10 bg-black text-white flex items-center justify-center rounded-full">
							<Logo />
						</div>
					</div>
					<h2 className="text-2xl font-semibold text-center mb-4">
						{roleFromURL
							? `Sign in as a ${roleFromURL.charAt(0).toUpperCase() + roleFromURL.slice(1)}`
							: 'Sign in to your account'}
					</h2>
					<Form
						name="signup"
						onFinish={onFinish}
						className="space-y-4 flex flex-col items-center w-full max-w-md"
						initialValues={{
							remember: true,
						}}
					>
						<FormInput name="email" placeholder="Email*" type="email" />
						<FormInput
							name="password"
							placeholder="Password*"
							type="password"
						/>

						<div className="w-4/5 flex flex-wrap items-center justify-between gap-y-3">
							{/* <Form.Item name="remember" noStyle valuePropName="checked">
								<Checkbox>Remember me</Checkbox>
							</Form.Item> */}

							<a
								className="text-sm text-green-600 w-full sm:w-auto text-left sm:text-right"
								onClick={() => {
									Navigate('/email-screen');
								}}
							>
								Forgot your password?
							</a>
						</div>

						<Form.Item className="w-4/5">
							<Button
								htmlType="submit"
								block
								className="w-4/5 bg-green-600 text-white rounded p-5"
							>
								{loading ? <Spin /> : 'Sign In '}
							</Button>
						</Form.Item>

						{roleFromURL !== 'admin' && <p className="text-center text-sm">
							Don’t have an account?{' '}
							<a
								onClick={() => Navigate('/signup')}
								className="text-green-600 cursor-pointer"
							>
								Sign Up
							</a>
						</p>}
					</Form>
					{roleFromURL !== 'admin' && <Google />}
				</div>
				<div className="hidden md:flex w-1/2 h-full bg-gray-100 items-center justify-center">
					<img src={learn} alt="Pencils" className="w-full h-full" />
				</div>
			</div>
		</div>
	);
};

export default Login;
